import React from 'react';
import { Row, Col } from 'antd';
import { Paragraph, Title } from '@/components/Typography';

import { NextButton } from './components/NextButton';
import { FileTable } from './components/FileTable';
import { SelectFilesProvider } from './context';
import { Filter } from './components/Filter';

export const SelectFile: React.FC = () => (
	<SelectFilesProvider>
		<Row gutter={[0, 30]} justify="center" align="middle">
			<Col offset={1} span={23}>
				<Row>
					<Col span={24}>
						<Title level={3}>Video selection</Title>
					</Col>
					<Col>
						<Paragraph>
							Select the video files for the operations that make up the workstation below
						</Paragraph>
					</Col>
				</Row>
			</Col>
			<Col offset={1} span={23}>
				<Filter />
			</Col>
			<Col offset={1} span={23}>
				<FileTable />
			</Col>
			<Col xs={24}>
				<NextButton />
			</Col>
		</Row>
	</SelectFilesProvider>
);
